import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../styles/AppTheme';
import { CustomMessageDialogStyles } from '../styles/CustomStyles';
import { AppConfig } from '../AppConfig';
import { AppHelper } from '../helpers/AppHelper';
import { Status } from './Status';
import { venueMarkerData } from '../data/data';
import { vsprintf } from 'sprintf-js';
import { Helper } from '../common/helpers/Helper';
import { Grid, Tooltip } from '@material-ui/core';
import { VenueStatusTiles } from './VenueStatusTiles';
import { UiHelper } from '../common/helpers/UiHelper';
import { Fade, Slide } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});
export class VenueDetails extends Component {
  constructor(props) {
    super(props)
    this.cards = []
    this.state = {}
  }

  _getFreeStorageClass(percentage) {
    console.log('percentage',percentage)
    if (percentage < 25) {
      return css(Styles.lowFreeStorage)
    }else if (percentage < 50) {
      return css(Styles.midFreeStorage)
    }else{
      return ''
    }
  }

  getTiles() {
    const allTiles = []
    if (!this.props.selectedDevice) return allTiles
    const props = this.props.selectedDevice
    // Version Code
    allTiles.push(
      {
        // icon: 'apps',
        title: 'OS Version | App Version',
        value: ((props.latestDeviceFeed && props.latestDeviceFeed.osVersion) ? Helper.getString('android') + ' ' + props.latestDeviceFeed.osVersion : Helper.getString('unknown')) +
        ' | ' +
        ((props.latestDeviceFeed && props.latestDeviceFeed.versionCode) ? '#' + props.latestDeviceFeed.versionCode : Helper.getString('unknown')),
        image: require('../assets/icons/venueStatus/app-version.svg')
      },
    )
    // Storage
    allTiles.push(
      {
        // icon: 'storage',
        title: 'Free Storage',
        image: require('../assets/icons/venueStatus/free-storage.svg'),
        value: (props.latestDeviceFeed && props.latestDeviceFeed.externalFree && props.latestDeviceFeed.externalTotal) ?
          <span className={this._getFreeStorageClass(AppHelper.calculatePercentage(props.latestDeviceFeed.externalFree, props.latestDeviceFeed.externalTotal))}>
            {vsprintf('%s/%s GB (%s)', [
              AppHelper.bytesToGigabytes(props.latestDeviceFeed.externalFree),
              AppHelper.bytesToGigabytes(props.latestDeviceFeed.externalTotal),
              AppHelper.calculatePercentage(props.latestDeviceFeed.externalFree, props.latestDeviceFeed.externalTotal, '%')
            ])}
          </span> : Helper.getString('unknown')
      },
    )
    // Os Version
    // allTiles.push(
    //   {
    //     // icon: 'adb',
    //     title: 'OS Version',
    //     image: require('../assets/icons/venueStatus/os-version.svg'),
    //     value: (props.latestDeviceFeed && props.latestDeviceFeed.osVersion) ? Helper.getString('android') + ' ' + props.latestDeviceFeed.osVersion : Helper.getString('unknown')
    //   },
    // )
    // Storage
    allTiles.push(
      {
        // icon: 'adjust',
        title: 'Status',
        image: require('../assets/icons/venueStatus/status.svg'),
        value: (props.latestDeviceFeed && props.latestDeviceFeed.currentTs) ? AppHelper.formatActiveTime(Helper.currentTs() - props.latestDeviceFeed.currentTs) : Helper.getString('unknown')
      },
    )
    // Os Version
    allTiles.push(
      {
        // icon: 'sync',
        title: 'Orientation',
        image: require('../assets/icons/venueStatus/orientation.svg'),
        value: (props._ORIENTATION) ? props._ORIENTATION : Helper.getString('unknown')
      },
    )
    return allTiles
  }
  //map and places
  getMapContainer = () => {
    return (
      <div id={'map'} className={css(Styles.mapContainer)}></div>
    )
  }
  isLocationAvailable = () => {
    return (this.props.selectedDevice && this.props.selectedDevice.info && this.props.selectedDevice.info.lat && this.props.selectedDevice.info.lon) ? true : false;
  }
  loadMap = (data) => {
    const deviceLocation = {
      lat: AppConfig.DEFAULT_MAP_LOCATION.LAT,
      lng: AppConfig.DEFAULT_MAP_LOCATION.LNG,
    }
    if (this.isLocationAvailable()) {
      deviceLocation.lat = this.props.selectedDevice.info.lat
      deviceLocation.lng = this.props.selectedDevice.info.lon
    }
    try {
      const iconImg = require('../assets/images/map-marker.svg')
      const map = new window.google.maps.Map(document.getElementById('map'), {
        zoom: 10,
        center: deviceLocation,
      })
      if (this.isLocationAvailable()) {
        const marker = new window.google.maps.Marker({
          position: deviceLocation,
          map,
          optimized: false,
          icon: iconImg
        });
      }
    }
    catch (err) {
      console.log('Google map load failed.', err);
    }
  }
  componentDidUpdate() {
    if(this.props.isOpen) setTimeout(()=>{ this.loadMap() },200)
  }
  onCloseModal() {
    this.props.onClosed()
  }
  render() {
    return (
      <Dialog
        open={this.props.isOpen || false}
        aria-labelledby={this.props.title}
        fullWidth={this.props.fullWidth || false}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({key:'dialogCloseIcon'})}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          {/* <div className={css(Styles.statusHolder)}>
            { this.getTiles().length > 0 && <Status items={this.getTiles()} spacing={1} tileSize={4} valueStyle={Styles.valueStyle} outerContainer={Styles.outerContainer} ></Status>}
          </div>
          <div className={css(Styles.container)}>
            { !this.isLocationAvailable() && <div className={css(Styles.locationNotAvailable)}>{Helper.getString('latLngNotFound')}</div> }
            {this.getMapContainer()}
          </div> */}
          <Grid container spacing={2}>
            <Grid key={'status_holder'} item xs={12} md={5}>
              <div className={css(Styles.statusHolder)} >
                { this.getTiles().length > 0 &&
                <VenueStatusTiles items={this.getTiles()} spacing={1} tileSize={4} valueStyle={Styles.valueStyle} outerContainer={Styles.outerContainer} ></VenueStatusTiles>}
              </div>
              <div className={css(Styles.deviceImageStatusHolder)} >
                <div className={css(Styles.deviceImageHolder)}>
                  {this.props.selectedDevice && this.props.selectedDevice.image &&
                  <img src={this.props.selectedDevice.image} className={css(Styles.deviceImage)} />
                  }
                  {!this.props.selectedDevice || !this.props.selectedDevice.image &&
                    <span>{Helper.getString('noVenueImage')}</span>
                  }
                </div>
              </div>
            </Grid>
            <Grid key={'map_holder'} item xs={12} md={7} className={css(Styles.mapHolder)}>
              {!this.isLocationAvailable() && <div className={css(Styles.locationNotAvailable)}>{Helper.getString('latLngNotFound')}</div>}
              {this.getMapContainer()}
            </Grid>
          </Grid>

        </div>
      </Dialog>
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  lowFreeStorage:{
    color: '#FF1512'
  },
  midFreeStorage:{
    color: '#FF8911'
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#121212',
    fontSize: 28,
    // fontWeight: 600
    '@media (max-width: 1024px)': {
      fontSize: 22,
      maxWidth: '70vw',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  modalContent: {
    minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: 16,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  contentImage: {
    maxWidth: '100%',
    maxHeight: 400,
    border: 'solid black 1px'
  },
  contentVideo: {
    width: '100%',
    height: 'auto',
    maxHeight: 400
  },
  statusHolder: {
    // display: 'flex',
    width: '100%',
    background: '#F7F7F9',
    borderRadius:16,
    float: 'left',
    paddingBottom: '8px'
  },
  container: {
    width: '100%',
    position: 'relative'
  },
  mapContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    height: '100%',
    borderRadius: 16,
    backgroundColor: '#f5f5f5',
    '@media (max-width: 1024px)': {
      borderRadius: 20,
      height: 400
    }
  },
  cardTitle: {
    fontSize: 18,
    margin: '10px 0px'
  },
  valueStyle: {
    color: AppTheme.buttonBg,
    fontSize: 20,
    minHeight: 50,
    display: 'flex',
    alignItems: 'center'
  },
  statusValueStyle: {
    color: AppTheme.buttonBg,
    minHeight: 50,
    display: 'flex',
    alignItems: 'center'
  },
  circleFill: {
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  outerContainer: {
    adding: '12px 18px 12px !important'
  },
  deviceStatusContainer:{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  locationNotAvailable:{
    position: 'absolute',
    zIndex: 999,
    fontWeight: 'bold',
    fontSize: '1.2rem',
    color: 'tomato',
    background: 'rgb(255, 255, 255)',
    borderRadius: 16,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'max-content',
    padding: '16px 14px'
  },
  mapHolder:{
    position: 'relative'
  },
  deviceImageStatusHolder:{
    width: '100%',
    background: 'rgb(247, 247, 249)',
    borderRadius: 16,
    float: 'left',
    marginTop: 10
  },
  deviceImageHolder:{
    padding: 10,
    height: 220,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden'
  },
  deviceImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    // borderRadius: 12
  }
})



// WEBPACK FOOTER //
// ./src/components/VenueDetails.js